<template>
  <div class="orders">
    <div class="header-container">
      <div class="header-left">
        <img class="bm-logo" src="../../src/assets/images/BMM_Color.png" @click="navHome()" />
      </div>
      <div v-if="!this.$route.params.order" class="search-input-container">
        <input class="search-input" :placeholder="placeholder" v-model="searchQuery" type="search"/>
        <img
          class="magnifier"
          src="../../src/assets/images/icons/0803-magnifier.svg"
          @click="navHome()"
        />
      </div>
    </div>
    <div class="main">
      <div class="left-panel">
        <div class="lp-header">
          <h1 v-if="user">WELCOME, {{user}}</h1>
          <h2 v-if="approver">
            You have
            <span style="font-weight:bold;">{{reviewedCount}}</span> order(s) that need review.
          </h2>
          <div
            class="status-filters"
            v-for="statusFilter in statusFilters"
            :key="statusFilter.key"
            @click="newStatusFilter(statusFilter)"
          >
            <img
              v-if='statusFilter.icon != "$"'
              :class="{ 'status-icon': true,  active: statusFilter.key === activeFilter.key }"
              :src="statusFilter.key === activeFilter.key ? statusFilter.activeIcon : statusFilter.icon"
            />
            <div
              v-if='statusFilter.icon == "$"'
              :class="{ 'dollar-icon': true,  active: statusFilter.key === activeFilter.key }"
            >$</div>
            <h3
              v-if="statusFilter.name"
              style="cursor: pointer"
              :class="{ active: statusFilter.key === activeFilter.key }"
            >{{ statusFilter.name.toUpperCase() }}</h3>
          </div>
          <div v-if="!approver">
            <h4>Administrative</h4>
            <div
              class="status-filters"
              v-for="admin in adminMenu"
              :key="admin.key"
              @click="newStatusFilter(admin)"
            >
              <img
                :class="{ 'status-icon': true,  active: admin.key === activeFilter.key }"
                :src="admin.key === activeFilter.key ? admin.activeIcon : admin.icon"
              />
              <h3
                v-if="admin.name"
                style="cursor: pointer"
                :class="{ active: admin.key === activeFilter.key }"
              >{{ admin.name.toUpperCase() }}</h3>
            </div>
          </div>
        </div>
        <div>
          <div class="order-portal">
            <img style="padding-right: 10px;" src="../../src/assets/images/icons/0334-cart.svg" />
            <div @click="toPortal()">BACK TO ORDER PORTAL</div>
          </div>
          <div class="logout-container">
            <img
              style="padding-right: 10px;"
              src="../../src/assets/images/icons/0766-exit-left.svg"
            />
            <div @click="logout()">LOG OUT</div>
          </div>
        </div>
      </div>
      <div class="right-panel" v-if="!this.$route.params.order && !adminStatus">
        <div class="right-container">
            <div class="rp-header">
              <div>{{activeFilter.name}}</div>
            </div>
            <data-table
              :headings="headings"
              :rows="activeTableData"
              :search-query="searchQuery"
              :perPage="rowCount"
              :page="pageNumber"
            >
              <template v-slot:emailSlot="slotProps">
                <img
                  @click.stop="resendPendingEmail(slotProps.row.id)"
                  style="cursor: pointer"
                  v-if='slotProps.row.status == "Pending" && !approver'
                  src="../../src/assets/images/icons/0151-envelope.svg"
                />
              </template>
            </data-table>
          <div class="arrows" v-if="pageCount > 1">
            <img
              @click="prevPage"
              style="margin-right:40px; cursor: pointer"
              src="../../src/assets/images/icons/0828-chevron-left.svg"
            />
            <img @click="nextPage" src="../../src/assets/images/icons/0829-chevron-right.svg" />
          </div>
        </div>
      </div>
      <order-details
        v-if="this.$route.params.order"
        :parentData="activeTableData"
        @reviewed="reduceReviewed"
        @clearStatusFilter="clearStatusFilter"
      ></order-details>
      <admin v-if="adminStatus" :statusFilter="activeFilter" :searchQuery="searchQuery"></admin>
    </div>
    <modal class="modal-screens" v-show="isModalOpen">
      <template v-slot: header>
        <div>{{modalHeader}}</div>
      </template>
      <template v-slot:body class="body">
        <div class="app-modal">
          <h3>Would you like to resend the Pending Order email?</h3>
        </div>
      </template>
      <template v-slot:footer>
        <button @click="commit" style="margin-right: 13px;">CONFIRM</button>
        <button @click="closeModal">CANCEL</button>
      </template>
    </modal>
  </div>
</template>

<script>
import OrderDetails from "@/views/OrderDetail.vue";
import Admin from "@/views/Admin.vue";
import DataTable from "@/components/DataTable.vue";
import { mapGetters } from "vuex";
import { GET_ALL_ORDERS, GET_APPROVER_ORDERS, RESEND_PENDING_EMAIL } from "@/store/actions.type";
import { LOGOUT } from "@/store/actions.type";
import Modal from "@/components/Modal.vue";

let statusFilters = [
  {
    icon: "$",
    name: "All Orders",
    key: "all"
  },
  {
    icon: require("../../src/assets/images/icons/0855-notification-circle.svg"),
    activeIcon: require("../../src/assets/images/icons/0855-notification-circle-blue.svg"),
    name: "Pending Review",
    key: "pending"
  },
  {
    icon: require("../../src/assets/images/icons/0858-checkmark-circle.svg"),
    activeIcon: require("../../src/assets/images/icons/0858-checkmark-circle-blue.svg"),
    name: "Approved Orders",
    key: "approved"
  },
  {
    icon: require("../../src/assets/images/icons/0859-cross-circle.svg"),
    activeIcon: require("../../src/assets/images/icons/0859-cross-circle-blue.svg"),
    name: "Revised Orders",
    key: "revised"
  }
];

let adminMenu = [
  {
    icon: require("../assets/images/icons/0287-user.svg"),
    activeIcon: require("../assets/images/icons/0287-user-blue.svg"),
    name: "Manage Approvers",
    key: "manage"
  },
  {
    icon: require("../assets/images/icons/0860-plus-circle.svg"),
    activeIcon: require("../assets/images/icons/0860-plus-circle-blue.svg"),
    name: "Assign Approvers",
    key: "assign"
  }
];

export default {
  name: "orders",
  components: {
    OrderDetails,
    DataTable,
    Admin,
    Modal
  },
  data() {
    return {
      sortField: null,
      statusFilters,
      activeFilter: statusFilters[0],
      searchQuery: "",
      adminMenu,
      adminStatus: false,
      activeTableData: [],
      ordersData: [],
      placeholder: "Search orders",
      pageNumber: 1,
      rowCount: 50,
      error: "",
      reviewedCount: "",
      isModalOpen: false,
      modalHeader: "",
      orderId: ""
    };
  },
  methods: {
    getAllOrders() {
      const loader = this.$loading.show();
      if (!this.approver) {
        this.$store.dispatch(GET_ALL_ORDERS).finally(() => {
          this.ordersData = this.orders;
          this.activeTableData = this.ordersData;
          loader.hide();
        });
      } else {
        this.$store.dispatch(GET_APPROVER_ORDERS, this.id).finally(() => {
          this.ordersData = this.orders;
          this.activeTableData = this.ordersData;

          let i = 0;
          this.orders.forEach(order => {
            if (order.status === "Pending" && order.approver_id === this.id) {
              i++;
            }
          });
          this.reviewedCount = i;

          loader.hide();
        });
      }
    },
    newStatusFilter(statusFilter) {
      if (this.activeFilter == statusFilter) {
        return;
      }
      if (this.activeFilter == "" || this.adminStatus) {
        this.getAllOrders();
      }

      this.pageNumber = 1;
      this.ordersData = this.$store.getters.orders;
      this.activeFilter = statusFilter;
      this.adminStatus = false;
      this.placeholder = "Search orders";

      switch (this.activeFilter.key) {
        case "all":
          this.activeTableData = this.$store.getters.orders;
          break;
        case "pending":
          this.activeTableData = this.ordersData.filter(data => {
            return data.status === "Pending";
          });
          break;
        case "approved":
          this.activeTableData = this.ordersData.filter(data => {
            return data.status === "Approved";
          });
          break;
        case "revised":
          this.activeTableData = this.ordersData.filter(data => {
            return data.status === "Revised";
          });
          break;
        case "manage":
          this.placeholder = "Search approvers";
          this.adminStatus = true;
          break;
        case "assign":
          this.placeholder = "Search customers";
          this.adminStatus = true;
          break;
        default:
          break;
      }

      this.$router
        .replace({
          name: "orders"
        })
        .catch(err => {
          this.error = err;
        });
    },
    logout() {
      this.$store.dispatch(LOGOUT).then(() => {
        this.$router.replace({ name: "login" });
      });
    },
    toPortal() {
      window.open("https://benjaminmooreportables.com/", "_blank");
    },
    nextPage() {
      if (this.pageNumber < this.pageCount && this.pageNumber != this.pageCount)
        this.pageNumber++;
    },
    prevPage() {
      if (this.pageCount >= this.pageNumber && this.pageNumber !== 1)
        this.pageNumber--;
    },
    reduceReviewed() {
      this.reviewedCount--;
    },
    clearStatusFilter() {
      this.activeFilter = "";
    },
    navHome() {
      this.newStatusFilter(this.statusFilters[0]);
    },
    resendPendingEmail(orderId) {
      this.orderId = orderId;
      this.isModalOpen = true;
      this.modalHeader = "CONFIRM";
    },
    closeModal() {
      this.isModalOpen = false;
    },
    commit() {
      const loader = this.$loading.show();
      this.$store
        .dispatch(RESEND_PENDING_EMAIL, {
          email: this.userEmail,
          orderId: this.orderId
        })
        .then(() => {
          loader.hide();
          this.isModalOpen = false;
          this.$notify({
            text: "Pending Email Send",
            classes: "vue-notification",
            position: "top center",
            type: "success"
          });
        })
        .catch(err => {
          this.$notify({
            text: "Pending Email Not Sent",
            classes: "vue-notification",
            position: "top center",
            type: "error"
          });
          this.error = err;
          loader.hide();
        });
    }
  },
  computed: {
    ...mapGetters({
      orders: ["orders"]
    }),
    orders() {
      let orders = this.$store.getters.orders;
      if (this.activeFilter.key) {
        switch (this.activeFilter.key) {
          case "all":
            break;
          case "pending":
            orders = orders.filter(data => {
              return data.status === "Pending";
            });
            break;
          case "approved":
            orders = orders.filter(data => {
              return data.status === "Approved";
            });
            break;
          case "revised":
            orders = orders.filter(data => {
              return data.status === "Revised";
            });
            break;
          default:
            break;
        }
      }

      return orders;
    },
    user() {
      let name = this.$store.state.auth.user.name;
      if (name) {
        name = name
          .toUpperCase()
          .split(" ")
          .slice(0, -1)
          .join(" ");
        if (name == "") {
          name = this.$store.state.auth.user.name;
        }
      }
      return name;
    },
    userEmail(){
      return this.$store.state.auth.user.email
    },
    id() {
      return this.$store.state.auth.user.id;
    },
    approver() {
      return this.$store.getters.isApprover;
    },
    headings() {
      if (!this.approver) {
        if (this.activeFilter.key == "all") {
          return [
            {
              label: "Order",
              key: "order_name",
              sortType: "number"
            },
            {
              label: "Venue Name",
              key: "venue_name"
            },
            {
              label: "Event Date",
              key: "event_date",
              sortable: false
            },
            {
              label: "Date",
              key: "created_at",
              filter: "date",
              sortType: "date",
              defaultSort: true,
              sortReverse: true
            },
            {
              label: "Customer",
              key: "customer_name"
            },
            {
              label: "Quantity",
              key: "quantity",
              sortType: "number"
            },
            {
              label: "Status",
              key: "status",
              keyClass: true
            },
            {
              label: "",
              key: "email",
              sortable: false
            }
          ];
        } else if (this.activeFilter.key == "pending") {
          return [
            {
              label: "Order",
              key: "order_name",
              sortType: "number"
            },
            {
              label: "Event Date",
              key: "event_date",
              sortable: false
            },
            {
              label: "Date",
              key: "created_at",
              filter: "date",
              sortType: "date",
              defaultSort: true,
              sortReverse: true
            },
            {
              label: "Customer",
              key: "customer_name"
            },
            {
              label: "Quantity",
              key: "quantity",
              sortType: "number"
            },
            {
              label: "",
              key: "email",
              sortable: false
            }
          ];
        }
        else if (this.activeFilter.key == "Revised") {
          return [
            {
              label: "Order",
              key: "order_name",
              sortType: "number"
            },
            {
              label: "Event Date",
              key: "event_date",
              sortable: false
            },
            {
              label: "Date",
              key: "created_at",
              filter: "date",
              sortType: "date",
              defaultSort: true,
              sortReverse: true
            },
            {
              label: "Customer",
              key: "customer_name"
            },
            {
              label: "Quantity",
              key: "quantity",
              sortType: "number"
            }
          ];
        } else {
          return [
            {
              label: "Order",
              key: "order_name",
              sortType: "number"
            },
            {
              label: "Date",
              key: "created_at",
              sortType: "date",
              filter: "date",
              defaultSort: true,
              sortReverse: true
            },
            {
              label: "Customer",
              key: "customer_name"
            },
            {
              label: "Quantity",
              key: "quantity",
              sortType: "number"
            },
            {
              label: "Status",
              key: "status",
              keyClass: true
            }
          ];
        }
      } else {
        if (this.activeFilter.key == "all") {
          return [
            {
              label: "Order",
              key: "order_name",
              sortType: "number"
            },
            {
              label: "Venue Name",
              key: "venue_name"
            },
            {
              label: "Event Date",
              key: "event_date",
              sortable: false
            },
            {
              label: "Date",
              key: "created_at",
              filter: "date",
              sortType: "date",
              defaultSort: true,
              sortReverse: true
            },
            {
              label: "Customer",
              key: "customer_name"
            },
            {
              label: "Quantity",
              key: "quantity",
              sortType: "number"
            },
            {
              label: "Status",
              key: "status",
              keyClass: true
            }
          ];
        } else if (this.activeFilter.key == "pending") {
          return [
            {
              label: "Order",
              key: "order_name",
              sortType: "number"
            },
            {
              label: "Event Date",
              key: "event_date",
              sortable: false
            },
            {
              label: "Date",
              key: "created_at",
              filter: "date",
              sortType: "date",
              defaultSort: true,
              sortReverse: true
            },
            {
              label: "Customer",
              key: "customer_name"
            },
            {
              label: "Quantity",
              key: "quantity",
              sortType: "number"
            }
          ];
        } else if (this.activeFilter.key == "Revised") {
          return [
            {
              label: "Order",
              key: "order_name",
              sortType: "number"
            },
            {
              label: "Event Date",
              key: "event_date",
              sortable: false
            },
            {
              label: "Date",
              key: "created_at",
              filter: "date",
              sortType: "date",
              defaultSort: true,
              sortReverse: true
            },
            {
              label: "Customer",
              key: "customer_name"
            },
            {
              label: "Quantity",
              key: "quantity",
              sortType: "number"
            }
          ];
        } else {
          return [
            {
              label: "Order",
              key: "order_name",
              sortType: "number"
            },
            {
              label: "Date",
              key: "created_at",
              sortType: "date",
              filter: "date",
              defaultSort: true,
              sortReverse: true
            },
            {
              label: "Customer",
              key: "customer_name"
            },
            {
              label: "Quantity",
              key: "quantity",
              sortType: "number"
            },
            {
              label: "Status",
              key: "status",
              keyClass: true
            }
          ];
        }
      }
    },
    pageCount() {
      let l = this.activeTableData.length,
        s = this.rowCount;
      return Math.ceil(l / s);
    }
  },
  watch: {
    searchQuery (val) {
      if(val){
        this.pageNumber = 1;
      }
    }
  },
  created() {
    this.getAllOrders();
  }
};
</script>

<style lang="scss" scoped>
h1 {
  margin: 30px 0 40px 0;
}

h2 {
  font-weight: normal;
  font-size: 18px;
}

h3 {
  margin: 10px 0px;
  font-size: 14px;
  font-weight: normal;
  &.active {
    cursor: default !important;
    font-family: "Proxima SemiBold";
  }
}

h4 {
  margin-top: 40px;
  margin-bottom: 0;
  font-weight: 900;
  font-size: 18px;
  font-family: "Proxima SemiBold";
}

.app-modal {
  h3 {
    font-weight: 900;
    margin: 5px 0;
    font-size: 20px;
    font-family: "Proxima SemiBold";
  }
}

::placeholder {
  color: #c3cfd9;
}

.orders {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.header-container {
  display: flex;
  justify-content: space-between;
  background-color: white;
  border-bottom: 2px solid #efefef;
}

.header-left {
  display: flex;
  align-items: center;
  padding: 15px 35px;
}

.role {
  background-color: #dfe7ed;
  font-size: 20px;
  font-weight: 900;
  padding: 4px 8px;
}

.logo {
  font-size: 30px;
  margin: 20px 40px;
}

.main {
  display: flex;
  height: 100%;
  width: 100%;
}

.left-panel {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  margin-left: 40px;
  width: 300px;
}

.lp-header {
  display: flex;
  flex-direction: column;
  text-align: left;
  width: 180px;
}

.status-filters {
  display: flex;
  align-items: center;
}

.status-icon {
  margin-right: 10px;
  width: 24px;
  font-size: 24px;
  color: black;
  &.active {
    color: #588bcb;
  }
}

.dollar-icon {
  font-family: "Linear";
  font-size: 24px;
  margin-right: 10px;
  padding-left: 4.5px;
  padding-bottom: 1px;
  border-radius: 25px;
  border: 1px solid black;
  width: 17px;
  height: 21px;
  &.active {
    color: #588bcb;
    border: 1px solid #588bcb;
  }
}

.logout-container {
  margin-bottom: 35px;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  font-family: "Proxima SemiBold";
}

.order-portal {
  margin-bottom: 20px;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  font-family: "Proxima SemiBold";
}

.right-panel {
  width: 100%;
  background-color: white;
  display: flex;
  flex-direction: column;
}

.right-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  position: fixed;
  width: calc(100% - 400px);
  height: calc(100% - 84px);
  left: 350px;
  top: 84px;
}

.rp-header {
  display: flex;
  justify-content: space-between;
  font-size: 24px;
  font-weight: bold;
  padding: 30px 0px 15px;
  font-family: "Proxima Semibold";
}

.arrows {
  align-self: flex-end;
  display: flex;
  justify-content: flex-end;
  margin-top: 15px;
  cursor: pointer;
}

.search-input-container {
  margin-right: 80px;
  display: flex;
}

.search-input {
  margin: auto 0;
  width: 300px;
  padding-left: 15px;
  border-color: #8b8b8b;
}

.magnifier {
  height: 20px;
  margin: auto 0;
  padding: 12px;
  background: #2266bb;
}

.deny-info {
  display: flex;
  border-radius: 25px;
  border: 1px solid #2266bb;
  color: #2266bb;
  font-family: "Linear";
  font-size: 18px;
  padding-left: 9.5px;
  padding-top: 3px;
  width: 12.5px;
  height: 19px;
  &:hover {
    color: #8b8b8b;
    border: 1px solid #8b8b8b;
  }
}
</style>